/*
 * @Author: Xwh
 * @Date: 2022-11-30 10:44:45
 * @LastEditors: xiangwenheng
 * @LastEditTime: 2022-12-15 15:15:06
 * @Description: 按钮权限-自定义指令
 */

const premission = (el,bindings) => {
  const currentRoute = localStorage.getItem('toCurrentRouteBusi')
  const arr = localStorage.getItem('btnPermissionsListBusi')
  const role = JSON.parse(arr)
  let permissions  = []
  const chooseRole = role.find(item => item.menuPath === currentRoute)
  if(chooseRole && chooseRole.buttons && chooseRole.buttons.length){
    chooseRole.buttons.forEach(item=>{
      permissions.push(item.permission)
    })
  }else{
    permissions = []
  }
  const hasPemission = permissions.includes(bindings.value)//bindings.value为使用指令时的 指令值
  if(!hasPemission){//没有相应权限时，删除此按钮
    setTimeout(()=>{
      el.parentNode.removeChild(el)
    },0)
  }
}

export default premission
